(() => {
  const container = document.querySelector('[data-infinite-scroll]');
  if (!container) return;

  // Get settings from data attributes
  const scrollPushEnabled = container.getAttribute('data-scroll-push') === 'true';
  const scrollSpeedSetting = parseInt(container.getAttribute('data-scroll-speed')) || 1;
  const scrollDirectionSetting = container.getAttribute('data-scroll-direction') || 'left';

  // State variables
  let isScrolling = true;
  let animationFrameId = null;
  let currentScrollVelocity = 0;

  // Calculate scroll speed
  const baseSpeed = Math.max(scrollSpeedSetting, 1) * 0.5;
  const scrollDirection = scrollDirectionSetting === 'right' ? -1 : 1;
  const scrollSpeed = baseSpeed * scrollDirection;

  // Get original items
  let originalItems = Array.from(container.querySelectorAll('.testimonial__item'));
  let hasCloned = false;

  // Clone items for infinite loop
  function cloneItemsOnce() {
    if (hasCloned) return;
    hasCloned = true;

    for (let i = 0; i < 2; i++) {
      originalItems.forEach(item => {
        container.appendChild(item.cloneNode(true));
      });
    }
  }

  // Smooth scroll animation
  function smoothScroll() {
    currentScrollVelocity = isScrolling ? scrollSpeed : currentScrollVelocity * 0.92;
    container.scrollLeft += currentScrollVelocity;

    // Calculate dimensions
    const scrollLeft = container.scrollLeft;
    const itemWidth = originalItems[0]?.offsetWidth || 0;
    const totalOriginalWidth = originalItems.length * (itemWidth + 20);

    // Infinite scroll logic
    if (scrollDirection === 1) {
      if (scrollLeft > totalOriginalWidth + (totalOriginalWidth / 2)) {
        container.scrollLeft = totalOriginalWidth / 2;
      }
    } else {
      if (scrollLeft < totalOriginalWidth / 2) {
        container.scrollLeft = totalOriginalWidth + (totalOriginalWidth / 2);
      }
    }

    animationFrameId = requestAnimationFrame(smoothScroll);
  }

  // Start animation
  function startAnimation() {
    if (hasCloned) return;
    cloneItemsOnce();

    setTimeout(() => {
      const itemWidth = originalItems[0]?.offsetWidth || 0;
      const totalOriginalWidth = originalItems.length * (itemWidth + 20);

      isScrolling = true;
      container.scrollLeft = scrollDirection === 1
        ? totalOriginalWidth / 2
        : totalOriginalWidth + (totalOriginalWidth / 2);

      smoothScroll();
    }, 50);
  }

  // Start on first interaction or timeout
  const interactionListener = () => {
    startAnimation();
    container.removeEventListener('scroll', interactionListener);
    container.removeEventListener('mouseenter', interactionListener);
    container.removeEventListener('touchstart', interactionListener);
  };

  container.addEventListener('scroll', interactionListener, { passive: true });
  container.addEventListener('mouseenter', interactionListener, { passive: true });
  container.addEventListener('touchstart', interactionListener, { passive: true });
  setTimeout(startAnimation, 2000);

  // Handle scroll pause on hover/touch
  if (scrollPushEnabled) {
    const items = container.querySelectorAll('.testimonial__item');

    const pauseScroll = () => { isScrolling = false; };
    const resumeScroll = () => { isScrolling = true; };

    items.forEach(item => {
      item.addEventListener('mouseenter', pauseScroll);
      item.addEventListener('mouseleave', resumeScroll);
      item.addEventListener('touchstart', pauseScroll, { passive: true });
      item.addEventListener('touchend', resumeScroll, { passive: true });
    });

    container.addEventListener('mouseenter', pauseScroll);
    container.addEventListener('mouseleave', resumeScroll);
    container.addEventListener('touchstart', pauseScroll, { passive: true });
    container.addEventListener('touchend', resumeScroll, { passive: true });
  }

  // Cleanup
  window.addEventListener('beforeunload', () => {
    if (animationFrameId) cancelAnimationFrame(animationFrameId);
  });
})();